module.exports = __webpack_public_path__ + "img/logoAnimhead.59109881.png";